export enum EventNames {
  disconnect = "disconnect",
  connection = "connection",
  connect = "connect",
}

export enum CustomEventNames {
  newGameInit = "NEW_GAME_INIT",
  putOnWait = "PUT_ON_WAIT",
  foundAMatch = "FOUND_A_MATCH",
  opponentDisconnected = "OPPONENT_DISCONNECTED",
  moveMade = "MOVE_MADE",
}
